import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute untuk Learner routes
 * Hanya mengecek apakah ada token
 * Error learner-id akan di-handle oleh apiConfig interceptor yang sudah ada
 */
const LearnerProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    console.log('❌ No token found, redirecting to login...');
    return <Navigate to="/learner/login" replace />;
  }

  // Token ada, allow akses
  // Error learner-id akan di-handle oleh apiConfig interceptor
  return children;
};

export default LearnerProtectedRoute;
